import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-brand-border bg-white text-center text-brand-muted text-sm" data-id="element-55">
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-56">
        <p className="text-brand-forest font-heading font-bold uppercase tracking-wide text-base" data-id="element-57">
          Tiroides en Rescate™
        </p>
        <p className="text-xs" data-id="element-58">
          © Tiroides en Rescate 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] text-brand-muted/70 leading-relaxed" data-id="element-59">
          Aviso legal: La información proporcionada en este material es de
          carácter educativo y no sustituye el consejo médico profesional.
          Consulta a tu médico antes de iniciar cualquier cambio en tu dieta o
          estilo de vida, especialmente si tomas medicamentos para la tiroides.
        </p>
      </div>
    </footer>;
}